
class ClientApi {
static instance;

constructor() {}

  static getInstance() {
    if (!ClientApi.instance) {
      ClientApi.instance = new ClientApi();
    }
    return this.instance;
  }

  /**
   * @description 调用客户端方法
   */
  JSCallNative(
    actionName,
    parameters,
    callbackActionName,
  ) {
    const params = {
      actionName,
      parameters,
      callbackActionName,
    };
    console.log(params);
    if (!window.appJSBridge.JSCallNative) {
      console.error('JSCallNative未定义');
      return;
    }
    window.appJSBridge.JSCallNative(JSON.stringify(params));
  }
}

export default ClientApi;



// WEBPACK FOOTER //
// ./src/common/js/bridge/ClientApi.js